import { useState } from 'react';
import { NWClient } from '../../../client/NWClient';
import { Helpers } from '../../../common/helpers/helpers';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';
import { fetchDocumentTemplates } from '../../../slices/document-templates/documentTemplatesSlice';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { LibraryItem } from '../components/library-list/types';
import { useTranslation } from 'react-i18next';
import { showMessage } from '../../../slices/show-plan-upgrading-message/showPlanUpgradingMessage';

export const useLibraryFunctions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [libraryItemForGenerator, setLibraryItemForGenerator] = useState<LibraryItem>(null);
  const [pendingDownload, setPendingDownload] = useState<boolean>(false);
  const [planUpgradingMessage, setPlanUpgradingMessage] = useState<boolean>(false);
  const [disclaimerMessage, setDisclaimerMessage] = useState<boolean>(false);
  const handleS3DownloadLink = (id: number, filename: string) => {
    setPendingDownload(true);
    NWClient.downloadLibraryDocument(id, filename)
      .catch((error) => {
        const errorMessage = Helpers.returnErrorText(error);
        toast.error(errorMessage.toString());
      })
      .finally(() => {
        setPendingDownload(false);
      });
  };

  const handleLibraryItemCopy = (data: any, id: number) => {
    NWClient.get(`document-library-html`, id)
      .then((response: any) => {
        data.content = response.html;
        return NWClient.post('document-template', data, false);
      })
      .then(() => {
        navigate(`${ROUTES.DOCUMENT_LIBRARY}?ownLibrary=true`);
        toast.success('Document copied successfully !');
      })
      .catch((error) => {
        if (
          error.response?.data?.errors?.length > 0 &&
          error.response?.data?.errors[0] === t('messages.exceededPlanLimits')
        ) {
          setPlanUpgradingMessage(true);
        } else {
          const errorMessage = Helpers.returnErrorText(error);
          toast.error(errorMessage.toString());
        }
      });
  };

  const handleTemplateCopy = (data: any, id: number, category?: string) => {
    NWClient.post('document-template', data, false)
      .then(() => {
        dispatch(fetchDocumentTemplates({ data: { user: id, category } }));
        toast.success('Document copied successfully !');
      })
      .catch((error) => {
        if (
          error.response?.data?.errors?.length > 0 &&
          error.response?.data?.errors[0] === t('messages.exceededPlanLimits')
        ) {
          dispatch(showMessage(t('messages.monthLimitReached')));
        } else {
          const errorMessage = Helpers.returnErrorText(error);
          toast.error(errorMessage.toString());
        }
      });
  };

  const navigateToTemplatePage = (category: string, id: number) => {
    navigate(`${ROUTES.DOCUMENT_LIBRARY}/${category}/${id}?templateViewEditMode=true`);
  };

  return {
    handleS3DownloadLink,
    handleLibraryItemCopy,
    planUpgradingMessage,
    setPlanUpgradingMessage,
    pendingDownload,
    navigateToTemplatePage,
    handleTemplateCopy,
    disclaimerMessage,
    setDisclaimerMessage,
    libraryItemForGenerator,
    setLibraryItemForGenerator,
  };
};
